export default "__VITE_ASSET__BTBQQSTU__"